<!-- youtube-desktop-03 preview — YouTube watch page (desktop), square image ad at the top of the up-next column -->
<app-desktop-frame>
  <div class="gs-page d-flex flex-column">
    <!-- START: Header -->
    <div class="gs-header d-flex flex-row align-items-center">
      <i class="bi bi-list gs-menu"></i>
      <div class="gs-brand d-flex flex-row align-items-center">
        <svg class="gs-logo" viewBox="0 0 24 17" aria-hidden="true" focusable="false">
          <rect width="24" height="17" rx="5" ry="5" fill="#ff0000" />
          <polygon points="9.6,4.4 17,8.5 9.6,12.6" fill="#fff" />
        </svg>
        <span class="gs-wordmark">YouTube</span>
      </div>
      <div class="gs-search d-flex flex-row" aria-hidden="true">
        <span class="gs-search-input"></span>
        <span class="gs-search-button"></span>
      </div>
      <span class="gs-account" aria-hidden="true"></span>
    </div>
    <!-- END: Header -->

    <div class="gs-body d-flex flex-row">
      <div class="gs-main d-flex flex-column" aria-hidden="true">
        <div class="gs-player d-flex flex-column">
          <div class="gs-video d-flex flex-column">
            <span class="gs-skip d-flex align-items-center">
              Skip <i class="bi bi-skip-end-fill"></i>
            </span>
            <span class="gs-progress">
              <span class="gs-progress-fill"></span>
            </span>
          </div>
          <div class="gs-controls d-flex flex-row align-items-center">
            <i class="bi bi-play-fill"></i>
            <i class="bi bi-skip-end-fill"></i>
            <i class="bi bi-volume-up"></i>
            <span class="gs-spacer"></span>
            <i class="bi bi-badge-cc"></i>
            <i class="bi bi-gear"></i>
            <i class="bi bi-square"></i>
            <i class="bi bi-fullscreen"></i>
          </div>
        </div>

        <span class="gs-bar gs-bar-dark gs-bar-heading"></span>
        <span class="gs-bar gs-bar-dark gs-bar-heading-2"></span>
        <span class="gs-divider"></span>

        <div class="gs-owner d-flex flex-row align-items-center">
          <span class="gs-avatar"></span>
          <span class="gs-spacer"></span>
          <span class="gs-subscribe"></span>
        </div>

        <div class="gs-desc-lines d-flex flex-column">
          <span *ngFor="let _ of descLines; let last = last" class="gs-bar gs-bar-line" [class.gs-bar-line-short]="last"></span>
        </div>
      </div>

      <div class="gs-side d-flex flex-column">
        <!-- START: Real ad -->
        <div class="gs-row d-flex flex-row align-items-start">
          <a class="gs-creative" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
            <img *ngIf="creativeImage" class="gs-creative-image" [src]="creativeImage" alt="" />
            <div *ngIf="!creativeImage" class="gs-creative-image creative-missing">{{ missingDimensionLabel }}</div>
            <span class="gs-open d-flex align-items-center justify-content-center"><i class="bi bi-box-arrow-up-right"></i></span>
          </a>
          <div class="gs-text">
            <h4 class="gs-title">{{ headline }}</h4>
            <div class="gs-desc">{{ description }}</div>
            <div class="gs-meta"><strong>Sponsored</strong> &middot; Valamar</div>
            <a class="gs-cta d-inline-flex align-items-center" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
              {{ ctaText }}
              <i class="bi bi-box-arrow-up-right"></i>
            </a>
          </div>
          <div class="gs-actions d-flex flex-column align-items-end">
            <i class="bi bi-info-circle gs-info"></i>
            <i class="bi bi-three-dots-vertical gs-more"></i>
          </div>
        </div>
        <!-- END: Real ad -->

        <!-- Skeleton up-next suggestions -->
        <div *ngFor="let _ of fillerRows" class="gs-row d-flex flex-row align-items-start" aria-hidden="true">
          <span class="gs-thumb d-flex align-items-center justify-content-center">
            <span class="gs-play d-flex align-items-center justify-content-center"><i class="bi bi-play-fill"></i></span>
          </span>
          <div class="gs-bars d-flex flex-column">
            <span class="gs-bar gs-bar-dark gs-bar-top"></span>
            <span class="gs-bar gs-bar-sub"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-desktop-frame>
